
import React, { memo, useState, useEffect } from "react";

import hiImg from "assets/images/wave-hand.svg";
import BookNowModal from "components/Dashboard/New/BookNowModal";
import ReactHtmlParser from "react-html-parser";
import API from "api.js";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Play from "assets/images/play.svg"
import ExamPopup from "components/PopUps/ExamPopup";
import { MdOutlineTouchApp } from "react-icons/md";
import { isWhiteLabel } from "utils/whiteLabel";

const NotificationArea = memo(function NotificationArea({
	loggedInUser: {
		name, email, active_subscription
	},mockData,examDate,setExamDate,examDatePopup,loadDashboardData
}) {
    
	const [bookNow, setBookNow] = useState(false);
	const [freeUser, setFreeUser] = useState(true);
	const [notification, setNotification] = useState("");
	const [examIsOpen, setExamIsOpen] = useState(false);
	const navigate = useNavigate()
    const user = useSelector((state) => state.user);
	const toggle = () => {
		setBookNow(prevState => !prevState);
	}

	const salutation = () => {
		const today = new Date();
		const currentHours = today.getHours();

		let salute = "";
		if (currentHours < 12) {
			salute = "Good Morning";
		} else if (currentHours < 18) {
			salute = "Good afternoon";
		} else {
			salute = "Good Evening";
		}

		return salute;
	}

	const buttonVisibility = () => {
		return user?.session_type ?  "hidden":"visible";
	}
	
	useEffect(() => {
		if (active_subscription && active_subscription.length > 0) {
			setFreeUser(false);
		}
	}, [active_subscription]);


	  const toggleExam = () => setExamIsOpen((prevState) => !prevState);
		  const saveExamDate = (e, selected_date) => {
			return API({
			  url: "updateExamDate",
			  method: "POST",
			  data: { exam_date: selected_date },
			})
			  .then((res) => {
				const { days_left } = res.data;
				loadDashboardData();
				toggleExam();
				setExamDate(selected_date);
			  })
			  .catch((err) => {
				console.log("err", err);
			  });
		  };
		  
	//  useEffect(() => {
	// 	setExamIsOpen(examDatePopup);
	//   }, [examDatePopup]);
	
	return (
		<div id="tour-welcome"  className="pr-md-0">
			<div className="booknow-card">
				<h2 className="mb-1">
				{salutation()}, {name} <img src={hiImg} alt="Hello" />
				</h2>
				<div className="d-flex gap-2 align-items-center justify-content-between notification-card">
				    <div>
						{
						 mockData?.exam_date ? 
						<p className="m-0 FS20FW500 fw-600 dashboard-notification mb-0" style={{letterSpacing:"1px"}}>{mockData?.days_left} days until your exam
						</p>
						: 
						<>
						  <a
					href="javascript:void(0)"
					className="booknow-btn dashboard-book-now gap-1 mt-1"
					onClick={()=>{setExamIsOpen(true)}}
					style={{
						visibility: buttonVisibility(),
						height:"fit-content",
						maxWidth:"145px",
						padding:"7px 10px"
					}}
				   >
			         Set Exam Date<i className="fa fa-calendar-o" aria-hidden="true"></i> 
				    </a>
						</>
						}
					<p className="m-0 FS20FW500 fw-600 dashboard-notification" style={{letterSpacing:"1px"}}>Let's make every day count.</p>
					</div>
				<div className="d-flex gap-3 dashboard-notification-btns">
						<button className="primary-btn" onClick={() => navigate("/admin/test-material")}>
							Start Today's Practice
						<img src={Play} alt="practice" className="mx-1"/>
						</button>
			      {!isWhiteLabel() && !user?.session_type && (
					 <a
					href="javascript:void(0)"
					className="booknow-btn dashboard-book-now"
					onClick={toggle}
					style={{
						// visibility: buttonVisibility(),
						height:"fit-content",
						maxWidth:"fit-content"
					}}
				>
					{/* <i className="fa fa-calendar-o" aria-hidden="true"></i>  */}
					Book a Free Trial{" "}<MdOutlineTouchApp size={20}/>
				</a>
					)
				  }
				</div>
				</div>
			</div>

			{bookNow &&
				<BookNowModal
					isOpen={bookNow}
					toggle={toggle}
				/>
			}
			{
		examIsOpen && (
		<ExamPopup
		isOpen={examIsOpen}
          toggle={toggleExam}
          submit={saveExamDate}
          examDate={examDate}
				/>
			)
		}
		</div>
	);
});
export default NotificationArea;